import * as React from "react";
import { IEventCustomAttribute } from "../../../classes/eventCustomAttribute";
import { CustomAttributeRow } from "./CustomAttributeRow";

export interface ICustomAttributeProps {
  customAttributes: IEventCustomAttribute[];
}

export const CustomAttributeList = (props: ICustomAttributeProps) => {

    return (
        <ul>    
        {
            props.customAttributes.map((att) => <CustomAttributeRow key={att.attributeId} name={att.name} value={att.value} dataType={att.dataType} />,
        )}            
        </ul>
    );
};
